import * as React from 'react';

import { cn } from '@/lib/utils';

// Version allégée de l'Avatar shadcn (sans @radix-ui/react-avatar) : image si fournie, sinon initiales
interface AvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
  src?: string | null;
  alt?: string;
  fallback: string;
}

const Avatar = React.forwardRef<HTMLSpanElement, AvatarProps>(
  ({ className, src, alt = '', fallback, ...props }, ref) => {
    const [failed, setFailed] = React.useState(false);
    return (
      <span
        ref={ref}
        className={cn(
          'relative flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary-500 text-xs font-semibold text-white select-none',
          className,
        )}
        {...props}
      >
        {src && !failed ? (
          <img src={src} alt={alt} className="h-full w-full object-cover" onError={() => setFailed(true)} />
        ) : (
          <span>{fallback}</span>
        )}
      </span>
    );
  },
);
Avatar.displayName = 'Avatar';

export { Avatar };
